import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type {
  CreateEnrollmentTokenRequest,
  EnrollmentTokenDto,
  EnrollmentTokenListRequest,
} from '@/types/enrollment';

export const enrollmentApi = {
  list(request: EnrollmentTokenListRequest = {}): Promise<PagedResult<EnrollmentTokenDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<EnrollmentTokenDto>>>('/enrollment-tokens', { params: request }));
  },
  getById(id: number): Promise<EnrollmentTokenDto> {
    return unwrap(apiClient.get<ApiResponse<EnrollmentTokenDto>>(`/enrollment-tokens/${id}`));
  },
  create(request: CreateEnrollmentTokenRequest): Promise<EnrollmentTokenDto> {
    return unwrap(apiClient.post<ApiResponse<EnrollmentTokenDto>>('/enrollment-tokens', request));
  },
  revoke(id: number, reason?: string): Promise<EnrollmentTokenDto> {
    return unwrap(apiClient.post<ApiResponse<EnrollmentTokenDto>>(`/enrollment-tokens/${id}/revoke`, { reason }));
  },
};
